import GoogleMapReact from "google-map-react";
import { useIntl } from "react-intl";

interface GoogleMapMarkerProps {
  lat: string;
  lng: string;
  text: string;
  onSelectionCallback: (latitude: string, longitude: string) => void;
}

const GoogleMapMarker = (props: GoogleMapMarkerProps) => {
  const { lat, lng, onSelectionCallback } = props;

  const clickOnMarker = () => onSelectionCallback(lat, lng);

  return (
    <button
      style={{
        position: "absolute",
        width: 50,
        height: 50,
        left: -50 / 2,
        top: -50 / 2,
        border: "5px solid #f44336",
        borderRadius: 40,
        backgroundColor: "white",
        textAlign: "center",
        color: "#3f51b5",
        fontSize: 16,
        fontWeight: "bold",
        padding: 4,
      }}
      onClick={clickOnMarker}
    >
      {props.text}
    </button>
  );
};

interface GoogleMapContainerProps {
  latitude: string;
  longitude: string;
  onSelectionCallback: (latitude: string, longitude: string) => void;
}

export const GoogleMapContainer = (props: GoogleMapContainerProps) => {
  const { formatMessage } = useIntl();
  const { latitude, longitude, onSelectionCallback } = props;

  const clickOnMap = ({ lat, lng }) => onSelectionCallback(lat, lng);

  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: 'AIzaSyCLHc2aIWclXHiAEIym6mxRr4c8lx-tIUY' }}
      defaultCenter={{
        lat: latitude,
        lng: longitude,
      }}
      defaultZoom={16}
      yesIWantToUseGoogleMapApiInternals
      onClick={clickOnMap}
    >
      <GoogleMapMarker
        onSelectionCallback={onSelectionCallback}
        lat={latitude}
        lng={longitude}
        text={formatMessage({ id: "sharedScreen.here" })}
      />
    </GoogleMapReact>
  );
};
